export default function Badge({ children, bg, color, className = '' }) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${className}`}
      style={{ background: bg, color }}
    >
      {children}
    </span>
  );
}
